// Shared trilingual vocabulary primitives — the vocabulary law's machine home
// (the category charter ADR): DOMAIN VOCABULARY (nouns the domain owns —
// category names, section names, member words, statuses, event words) lives
// inline in the shared package's registries, trilingual and typed, readable by
// BOTH ends (backend import sheets · frontend UI). Locale files keep PROSE
// (sentences, buttons, toasts). A missing language here fails compile — which
// is stronger than any missing-key lint.
/** Resolve an i18next-style language tag to a platform language. */
export function langOf(tag) {
    const base = tag.split('-')[0];
    return base === 'fr' || base === 'ar' ? base : 'en';
}
export function pickTri(label, lang) {
    return label[langOf(lang)];
}
/** CLDR-correct plural selection via the platform's own rules — no i18n
 *  framework involved, works identically in Node and the browser. */
export function pluralize(word, count, lang) {
    const forms = word[langOf(lang)];
    const rule = new Intl.PluralRules(langOf(lang)).select(count);
    return forms[rule] ?? forms.other;
}
